import { Input, InputProps, Form } from "antd";
import { FormItemProps } from "antd/lib/form/FormItem";
import { useTranslations } from "../../../translations/translations";

interface Props extends FormItemProps {
	inputProps?: InputProps;
}

const StreetFormItem = ({ inputProps, ...props }: Props) => {
	const t = useTranslations();

	return (
		<Form.Item
			label={t.street}
			{...props}
			rules={[
				{
					type: "string",
					max: 30,
					message: t.fieldInvalid,
				},
				...(props.required
					? [
							{
								required: true,
								message: t.fieldRequired,
							},
					  ]
					: []),
				...(props.rules || []),
			]}
			validateFirst
		>
			<Input maxLength={30} placeholder={t.streetPlaceholder} {...inputProps} />
		</Form.Item>
	);
};

export default StreetFormItem;
